import ProHome from "../../views/Pro/Home.vue";
import ProPlayers from "../../views/Pro/Players.vue";
import ProLessons from "../../views/Pro/Lessons.vue";
import ProOffers from "../../views/Pro/Offers.vue";
import ProMessages from "../../views/Pro/Messages.vue";
import ProMessage from "../../components/Shared/Single-message.vue";
import ProInvite from "../../views/Pro/Players/Invite.vue";
import ProPlayer from "../../views/Pro/Players/Player.vue";
import BookLesson from "../../components/Shared/Book-Lesson.vue";
import BookLessonConfirmation from "../../components/Shared/Book-Lesson-confirmation.vue";

import LessonRecords from "../../views/Pro/Lessons/LessonRecords.vue";

import ChangeLesson from "../../components/Shared/Change-Lesson.vue";

import LessonHistiryRecord from "../../views/Pro/Players/Player/Lesson.vue";

import ProMain from "../../views/Pro.vue";

export default [
    {
        path: "/pro",
        name: "Pro",
        redirect: { name: "proHome" },
        component: ProMain,
        children: [
            {
                path: "home",
                name: "proHome",
                meta: {
                    isAuth: true,
                },
                component: ProHome,
            },
            {
                path: "bag",
                name: "proBag",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Player/Profile/Bag.vue"),
            },
            {
                path: "profile",
                name: "proProfile",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Profile.vue"),
            },
            {
                path: "players",
                name: "proPlayers",
                meta: {
                    isAuth: true,
                },
                component: ProPlayers,
            },
            {
                path: "lessons",
                name: "proLesson",
                meta: {
                    isAuth: true,
                },
                component: ProLessons,
            },
            {
                path: "lessons/book",
                name: "proLessonBook",
                meta: {
                    isAuth: true,
                },
                component: BookLesson,
            },
            {
                path: "lessons/book/:id/confirmation",
                name: "proLessonBookConfirmation",
                meta: {
                    isAuth: true,
                },
                component: BookLessonConfirmation,
            },
            {
                path: "lessons/change/:id",
                name: "proLessonChange",
                meta: {
                    isAuth: true,
                },
                component: ChangeLesson,
            },
            {
                path: "lessons/diary",
                name: "proLessonDiary",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Manage-diary.vue"),
            },
            {
                path: "lessons/records",
                name: "proLessonRecords",
                meta: {
                    isAuth: true,
                },
                component: LessonRecords,
            },
            {
                path: "lessons/diary/:start/:end",
                name: "proLessonDiarySetting",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Lesson.vue"),
            },
            {
                path: "lessons/diary-availability",
                name: "proDiaryAvailability",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Diary-availability.vue"),
            },
            {
                path: "lessons/availability",
                name: "proLessonAvailability",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Manage-availability.vue"),
            },
            {
                path: "lessons/availability/:id",
                name: "proLessonAvailabilityDay",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Lessons-availability.vue"),
            },
            {
                path: "lessons/settings",
                name: "proLessonSettings",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Lesson-settings.vue"),
            },
            {
                path: "lessons/videosettings",
                name: "proVideoLessonSettings",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Lessons/Video-Lesson-settings.vue"),
            },
            {
                path: "offers",
                name: "proOffers",
                meta: {
                    isAuth: true,
                },
                component: ProOffers,
            },
            {
                path: "offers/new",
                name: "proOffersNew",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Offers/Offer-new.vue"),
            },
            {
                path: "offers/categories",
                name: "proOffersCategories",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Offers/Categories.vue"),
            },
            {
                path: "offers/:id",
                name: "proOffer",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Offers/Offer.vue"),
            },
            {
                path: "messages",
                name: "proMessages",
                meta: {
                    isAuth: true,
                },
                component: ProMessages,
            },
            {
                path: "players/invite",
                name: "proInvite",
                meta: {
                    isAuth: true,
                },
                component: ProInvite,
            },
            {
                path: "players/:id",
                name: "proPlayer",
                meta: {
                    isAuth: true,
                },
                component: ProPlayer,
            },
            {
                path: "players/pending/:id",
                name: "proPlayerPending",
                meta: {
                    isAuth: true,
                },
                component: ProInvite,
            },
            {
                path: "players/:id/history",
                name: "proPlayerHistory",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/History.vue"),
            },
            {
                path: "players/:id/history/lesson/:lesson",
                name: "proPlayerLesson",
                meta: {
                    isAuth: true,
                },
                component: LessonHistiryRecord,
            },
            {
                path: "players/:id/profile",
                name: "proPlayerProfile",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/Profile.vue"),
            },
            {
                path: "players/:id/messages",
                name: "proPlayerMessages",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/Messages.vue"),
            },
            {
                path: "players/:id/credits",
                name: "proPlayerCredits",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/Credits.vue"),
            },
            {
                path: "players/:id/skills",
                name: "proPlayerSkills",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/Skills.vue"),
            },
            {
                path: "players/:id/reminders",
                name: "proPlayerReminders",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Players/Player/Reminders.vue"),
            },
            {
                path: "messages/new",
                name: "proPlayerMessagesNew",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Messages/New-message.vue"),
            },
            {
                path: "messages/message/:id",
                name: "proMessage",
                meta: {
                    isAuth: true,
                },
                component: ProMessage,
            },
            {
                path: "messages/inbox",
                name: "proPlayerMessagesInbox",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Messages/Inbox.vue"),
            },
            {
                path: "messages/sent",
                name: "proPlayerMessagesSent",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Messages/Sent-messages.vue"),
            },
            {
                path: "messages/groups",
                name: "proPlayerMessagesGroups",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Messages/Groups.vue"),
            },
            {
                path: "messages/groups/:id",
                name: "proPlayerMessagesGroup",
                meta: {
                    isAuth: true,
                },
                component: () => import("../../views/Pro/Messages/Group.vue"),
            },
        ],
    },
];
